import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Checkbox as NextUICheckbox } from "@nextui-org/react";
import { useField } from "formik";
import React, { useCallback } from "react";
export var Checkbox = function Checkbox(props) {
  var _useField = useField(props.name || "checkbox"),
      _useField2 = _slicedToArray(_useField, 3),
      field = _useField2[0],
      helpers = _useField2[2];

  console.log("value", field.value);
  var onChange = useCallback(function (e) {
    helpers.setValue(e.target.checked);
  }, [helpers]);
  return /*#__PURE__*/React.createElement(NextUICheckbox, _extends({}, props, {
    initialChecked: field.value,
    onChange: onChange,
    onBlur: field.onBlur
  }));
};